import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { AbstractStep } from "@/component/assets/AbstractLeadForm/Steps/AbstractStep";
import { ButtonLegacy, FormRadio, List } from "@/shared/ui";

export interface StepFields {
	productName: string;
}

export class Step5a extends AbstractStep<StepFields> {
	protected initValues(): StepFields {
		return {
			productName: undefined,
		};
	}

	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		return (
			<>
				<Card.Header>
					<Card.Title className="text-center">Érdekel a gyorsított, digitális Babaváró opciónk?</Card.Title>
				</Card.Header>
				<Card.Body>
					<Card className="bg-erste mb-3">
						<Card.Header>
							<div className="h2 text-center pt-2 border-bottom-0">Erste Online Babaváró</div>
						</Card.Header>
						<Card.Body className="border-top-0 px-2">
							<List itemStyle="tick" variant="gold" size="sm" className="ml-0 mb-2">
								<List.Item>
									<strong className="text-uppercase">folyósítás akár 3 nap alatt</strong>
								</List.Item>
								<List.Item>
									<strong className="text-uppercase">nincs felesleges banki találkozó - </strong>
									<br />
									Csak szerződéskötésre kell bemenned
								</List.Item>
								<List.Item>
									<strong className="text-uppercase">ügyintézés otthonról - </strong>
									<br />
									Töltsd fel a szükséges dokumentumokat és értesülj minden döntésről a Bankmonitor
									Ügyfélportál felületen
								</List.Item>
								<List.Item>
									<strong className="text-uppercase">díjmentes</strong>
								</List.Item>
							</List>
						</Card.Body>
					</Card>
					<FormRadio
						variant="button"
						name="productName"
						options={[
							{ label: "Érdekel", value: "Erste Online Babaváró" },
							{ label: "Nem érdekel", value: "Babaváró" },
						]}
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<ButtonLegacy
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Kalkulálás befejezése
					</ButtonLegacy>
				</Card.Footer>
			</>
		);
	}

	protected getComponentName(): string {
		return "Step5a";
	}
}
